import React from "react";
import "./index.css";
import landingVideo from "../../assets/landing_video.mp4";

const TopContainer = () => {
  return (
    <div className="top-container">
      <div className="top-container-body">
        <div className="top-container-body-content">
          <div className="maximize">Maximize Sales With Our Advanced</div>
          <div className="erp">EPINICS ERP SOFTWARE SOLUTIONS</div>
        </div>

        <div className="top-container-video-wrap">
          <video
            className="top-container-video"
            src={landingVideo}
            autoPlay
            muted
            loop
            playsInline
          />
        </div>
      </div>
    </div>
  );
};

export default TopContainer;
